import { useTLang } from 'intl/intl';

export function useSOTotalDetailLang() {
  return {
    totalLabel: useTLang({ id: 'scheduleOrder.detail.totalLabel' }),
  };
}
